// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "../axios/axios";

// const VerifyEmailOtp = () => {
//   const [email, setEmail] = useState("");
//   const [otp, setOtp] = useState("");
//   const [message, setMessage] = useState("");

//   const [timeLeft, setTimeLeft] = useState(300); // 5 minutes in seconds
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (timeLeft <= 0) return;

//     const interval = setInterval(() => {
//       setTimeLeft((prev) => prev - 1);
//     }, 1000);

//     return () => clearInterval(interval);
//   }, [timeLeft]);

//   const formatTime = (seconds) => {
//     const m = Math.floor(seconds / 60);
//     const s = seconds % 60;
//     return `${m}:${s.toString().padStart(2, "0")}`;
//   };

//   const handleVerify = async (e) => {
//     e.preventDefault();
//     if (timeLeft <= 0) {
//       setMessage("OTP expired. Please request a new one.");
//       return;
//     }

//     try {
//       await axios.post("/auth/verify-otp", {
//         email,
//         otp,
//       });

//       navigate("/reset-password", { state: { email } });
//     } catch (error) {
//       setMessage(error.response?.data?.message || "Invalid OTP or Email.");
//     }
//   };

//   return (
//     <div>
//       <h2>Verify OTP</h2>
//       <p>
//         OTP will expire in: <strong>{formatTime(timeLeft)}</strong>
//       </p>
//       <form onSubmit={handleVerify}>
//         <input
//           type="email"
//           placeholder="Enter your email"
//           value={email}
//           required
//           onChange={(e) => setEmail(e.target.value)}
//         />
//         <input
//           type="text"
//           placeholder="Enter OTP"
//           value={otp}
//           required
//           onChange={(e) => setOtp(e.target.value)}
//         />
//         <button type="submit" disabled={timeLeft <= 0}>
//           Verify
//         </button>
//       </form>
//       <p style={{ color: "red" }}>{message}</p>
//     </div>
//   );
// };

// export default VerifyEmailOtp;

import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "../axios/axios";

const VerifyEmailOtp = () => {
  const [otp, setOtp] = useState("");
  const [message, setMessage] = useState("");
  const [timeLeft, setTimeLeft] = useState(300); // 5 mins

  const navigate = useNavigate();
  const location = useLocation();

  const email = location.state?.email;

  useEffect(() => {
    if (!email) {
      setMessage("No email provided. Please restart the process.");
    }
  }, [email]);

  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => setTimeLeft((prev) => prev - 1), 1000);
    return () => clearInterval(interval);
  }, [timeLeft]);

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s.toString().padStart(2, "0")}`;
  };

  const handleVerify = async (e) => {
    e.preventDefault();

    if (!email) {
      setMessage("Missing email. Try again from Forgot Password.");
      return;
    }

    if (timeLeft <= 0) {
      setMessage("OTP expired. Please request a new one.");
      return;
    }

    try {
      await axios.post("/auth/verify-otp", { email, otp });
      navigate("/reset-password", { state: { email } });
    } catch (error) {
      setMessage(error.response?.data?.message || "Invalid OTP.");
    }
  };

  return (
    <div
      className=" d-flex flex-column justify-content-center"
      style={{ height: "100vh" }}
    >
      <h2 className="fw-bold text-center mb-4 fw-bold">Verify OTP</h2>
      <div className="w-50 container">
        <p>
          OTP sent to: <strong>{email}</strong>
        </p>
        <p>
          Expires in: <strong>{formatTime(timeLeft)}</strong>
        </p>
        <form onSubmit={handleVerify}>
          <input
            className="form-control shadow-none mb-4"
            type="text"
            placeholder="Enter OTP"
            value={otp}
            required
            onChange={(e) => setOtp(e.target.value)}
          />
          <button
            type="submit"
            className="btn bg_maincolor text-white mb-4"
            disabled={timeLeft <= 0}
          >
            Verify
          </button>
        </form>

        <p style={{ color: "red" }}>{message}</p>
      </div>
    </div>
  );
};

export default VerifyEmailOtp;
